'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIDateRange from './UIDateRange';
import UIMicroDateInput from './UIMicroDateInput';
const DateRange = styled(UIDateRange).withConfig({
  displayName: "UIMicroDateRange__DateRange",
  componentId: "sc-1m7yhdz-0"
})(["display:inline-flex;"]);

const UIMicroDateRange = props => {
  return /*#__PURE__*/_jsx(DateRange, Object.assign({}, props));
};

UIMicroDateRange.propTypes = UIDateRange.propTypes;
UIMicroDateRange.defaultProps = Object.assign({}, UIDateRange.defaultProps, {
  DateInput: UIMicroDateInput
});
UIMicroDateRange.displayName = 'UIMicroDateRange';
export default UIMicroDateRange;